import { isTouchDevice } from './isTouchDevice'

export const checkHybridDevice = () => {
  const hasTouch = isTouchDevice()
  const hasMouse = matchMedia('(pointer: fine)').matches

  return hasTouch && hasMouse
}
